export function setListarEmpresas(state, empresas) {
    state.empresas = empresas
}

export function setDatosEmpresa(state, dato) {
    state.selectedEmpresa = dato;
    console.log('setDatosEmpresa');
}

export function empresaDatosError(state) {
    console.log(state);
    console.log('empresaDatosError');
}





